import { Region } from './utils/region'

let activeTenant: Region

export const setActiveTenant = (tenant: Region) => {
  activeTenant = tenant
}

export const getActiveTenant = () => activeTenant
